"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AckField;

var _react = _interopRequireDefault(require("react"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _formik = require("formik");

var _InputCheckbox = _interopRequireDefault(require("../InputCheckbox"));

var _AckField = require("./AckField.styled");

var __jsx = _react["default"].createElement;

// Although it looks like a checkbox (and it is a input type="checkbox"),
// the value saved to formik is the actual "defaultValue" passed to the component
function AckField(_ref) {
  var name = _ref.name,
      defaultValue = _ref.defaultValue,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["name", "defaultValue"]);
  return __jsx(_formik.Field, {
    name: name
  }, function (_ref2) {
    var _ref2$field = _ref2.field,
        value = _ref2$field.value,
        field = (0, _objectWithoutProperties2["default"])(_ref2$field, ["value"]),
        setFieldValue = _ref2.form.setFieldValue;
    return __jsx(_react["default"].Fragment, null, __jsx(_InputCheckbox["default"], (0, _extends2["default"])({
      name: name // destructure value so that setFieldValue works properly

    }, field, props, {
      onChange: function onChange(event) {
        // Pass to formik the defaultValue instead of checkbox native
        // value of "true"/"false". This saves us from extra workarounds
        // down in the road when dealing with DynamicForm and submit
        setFieldValue(name, event.target.checked ? defaultValue : '');
      }
    })), __jsx(_AckField.StyledFormFieldError, {
      name: name
    }));
  });
}